// Инициализация карусели баннеров
document.addEventListener('turbo:load', function() {
  // Проверяем наличие карусели на странице
  if (document.getElementById('advertBannerCarousel')) {
    // Инициализируем карусель
    $('#advertBannerCarousel').carousel({
      interval: 5000, // Автоматическое переключение каждые 5 секунд
      ride: 'carousel',
      wrap: true, // Зацикливаем карусель
      keyboard: true // Управление с клавиатуры
    });
  }
});
